import React from 'react';
import buildAccountUrl from '../../utils/buildAccountUrl';
import Tooltip from '@app/ui/sports-components/Tooltip';
import PropTypes from 'prop-types';

const platformIconNames = {
    1: 'x-twitter',
    2: 'instagram',
    3: 'facebook',
    4: 'youtube',
    23: 'tiktok',
};

const AccountTag = ({ account }) => {
    const url = account.profileUrl || buildAccountUrl(account);
    const isActiveAccount = account.activeSocialFilter;

    const tag = (
        <a
            href={url ? url : null}
            target="_blank"
            rel="noopener noreferrer"
            data-test="account-tag"
        >
            <div
                className={`gds-tag gds-tag--xs ${
                    isActiveAccount ? '' : 'gds-tag--danger'
                }`}
                onClick={e => e.stopPropagation()}
            >
                <i
                    className={`fab-fa6 fa-${
                        platformIconNames[account.platformId]
                    }`}
                />{' '}
                {account.username}
            </div>
        </a>
    );

    return isActiveAccount ? (
        tag
    ) : (
        <Tooltip
            text={`This account is not currently active for text tracking.\n Please reach out to your CSM or submit a support ticket if you have any questions.`}
            position="top"
        >
            {tag}
        </Tooltip>
    );
};

AccountTag.propTypes = {
    account: PropTypes.object,
};

export default AccountTag;
